


















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Role, DataFilterGroup, DataFilter } from '@/dto';
import { ContextsState } from '@/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';

@Component
export default class DataFilters extends Vue {
    @Prop({ type: Object, required: true }) public role!: Role;

    public defaultDataFilterGroupName: string = 'Data filter group';
    public defaultDataFilterKey: string = 'Key1';
    public defaultDataFilterValue?: string | null = null;

    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;

    public createDataFilterGroup(name?: string) {
        if (name) {
            name = name.trim();

            if (name.length > 0) {
                if (!this.role.dataFilterGroups) {
                    this.role.dataFilterGroups = [];
                }

                this.role.dataFilterGroups.push({
                    name,
                    filters: []
                });

                this.save();
            }
        }
    }

    public deleteDataFilterGroup(group?: DataFilterGroup) {
        if (group && this.role.dataFilterGroups) {
            this.role.dataFilterGroups = this.role.dataFilterGroups.filter(
                x => x !== group
            );

            this.save();
        }
    }

    public createDataFilter(
        group?: DataFilterGroup,
        key?: string,
        value?: string
    ) {
        if (group) {
            if (!group.filters) {
                group.filters = [];
            }

            group.filters.push({ key, value });

            this.save();
        }
    }

    public deleteDataFilter(
        group?: DataFilterGroup,
        filter?: DataFilter
    ) {
        if (group && filter && group.filters) {
            group.filters = group.filters.filter(
                x => x !== filter
            );

            this.save();
        }
    }

    private async save(): Promise<void> {
        const currentContextId = ContextsState.currentContextId;
        await this._fetchService!.put<Role>(
            '/contexts/' + currentContextId + '/roles/' + this.role!.id,
            this.role
        );
    }
}
